import { useEffect } from 'react';
import { useQuery as useQueryRelay } from '@atlassian/jira-relay-apollo-migration-utils/src/services/use-query/index.tsx';
import type {
	gqlJiraJsmServicesSearchServicesByIdQuery$data as gqlJiraJsmServicesSearchServicesByIdQueryData,
	gqlJiraJsmServicesSearchServicesByIdQuery$variables as gqlJiraJsmServicesSearchServicesByIdQueryVariables,
} from '@atlassian/jira-relay/src/__generated__/gqlJiraJsmServicesSearchServicesByIdQuery.graphql';
import { COMPASS_COMPONENT_PROPERTY } from '../../common/constants.tsx';
import { SEARCH_SERVICES_BY_ID_QUERY_AGG_RELAY } from './gql.tsx';

type QueryParams = {
	ids: string[];
	onCompleted?: (data: gqlJiraJsmServicesSearchServicesByIdQueryData | null) => void;
	onError?: (error: Error | undefined) => void;
};

export const useGetServicesById = ({ ids, onCompleted, onError }: QueryParams) => {
	const { data, loading, error } = useQueryRelay<
		gqlJiraJsmServicesSearchServicesByIdQueryVariables,
		gqlJiraJsmServicesSearchServicesByIdQueryData
	>(SEARCH_SERVICES_BY_ID_QUERY_AGG_RELAY, {
		variables: {
			ids,
			propertyKeys: [COMPASS_COMPONENT_PROPERTY],
		},
		fetchPolicy: 'network-only',
	});

	// onCompleted
	useEffect(() => {
		if (data) {
			onCompleted?.(data);
		}
	}, [data, onCompleted]);

	// onError
	useEffect(() => {
		if (error) {
			onError?.(error);
		}
	}, [error, onError]);

	return {
		data,
		loading,
		error,
	};
};
